import {
	UserHeaderActions,
	UserHeaderActionsProps,
} from './HeaderActions.types'
import { useEffect, useState } from 'react'

import clientGetToggleFromCookie from '@/utils/cookies/getToggleFromCookie'
import { getCurrentCart } from '@/services/cartService'
import matchByServiceTier from '@/utils/matchByServiceTier'
import matchByWorkingArea from '@/utils/matchByWorkingArea'
import { sendAnalytics } from '@audio-network/analytics'

export const useHeaderActions = ({
	user,
}: UserHeaderActions): UserHeaderActionsProps => {
	const [itemsCount, setItemsCount] = useState(0)

	useEffect(() => {
		const fetchCartCount = async (): Promise<void> => {
			await getCurrentCart().then((cart) => {
				if (cart) {
					setItemsCount(cart.itemsCount)
				}
			})
		}

		if (user) {
			fetchCartCount()
		}
	}, [user])

	const userMatchesServiceTierForServiceMenu = matchByServiceTier(user, {
		vip: true,
		accountManaged: true,
		assistedSales: true,
		ecommerce: false,
	})

	/** Allow users who are newly registered and presumed high value to see service menu etc. */
	const userMatchesWorkingAreaForServiceMenu = matchByWorkingArea(user, {
		tvAndFilm: true,
		advertising: true,
		brandsAndBusiness: true,
	})

	const showServiceMenu =
		user &&
		(userMatchesServiceTierForServiceMenu ||
			userMatchesWorkingAreaForServiceMenu)

	const handleAddToTeamButtonClick = (): void => {
		sendAnalytics({
			noun: 'Add to Team',
			pastTenseVerb: 'Clicked',
			eventParameters: {
				Location: 'Music App Navigation',
			},
		})
	}

	const handleServiceMenuButtonClick = (): void => {
		sendAnalytics({
			noun: 'Service Menu',
			pastTenseVerb: 'Clicked',
			eventParameters: {
				Location: 'Music App Navigation',
			},
		})
	}

	const handleAccountMenuButtonClick = (): void => {
		sendAnalytics({
			noun: 'Account Menu',
			pastTenseVerb: 'Clicked',
			eventParameters: { Location: 'Music App Navigation' },
		})
	}

	const showAddToTeam = clientGetToggleFromCookie('AddToTeam')

	return {
		showAddToTeam,
		handleAddToTeamButtonClick,
		handleServiceMenuButtonClick,
		handleAccountMenuButtonClick,
		showServiceMenu,
		itemsCount,
	}
}
